<script>
import {mapGetters} from "vuex";
import HorizontalStackedBarChart from "@/shared/charts/horizontal-stacked-bar-chart/horizontal-stacked-bar-chart.vue";
import DashboardTotal from "@/components/modules/new-dashboard/components/dashboard-total.vue";
import DashboardSpinner from "@/components/modules/new-dashboard/components/dashboard-spinner.vue";
import DashboardNoData from "@/components/modules/new-dashboard/components/dashboard-no-data.vue";

export default {
  name: "OrganizationsByStatus",
  components: {DashboardNoData, DashboardSpinner, DashboardTotal, HorizontalStackedBarChart},
  data() {
    return {
      colors: {
        label_evaluation_gold: "#FFBC05",
        label_evaluation_silver: "#D0CECE",
        label_evaluation_bronze: "#FF6D00",
        label_evaluation_recognition: "#2596D0",
        label_evaluation_inProgress: "#19A39C",
        label_evaluation_beingAudited: "#F32474",
      },
      groups: [
        "label_evaluation_awarded",
        "label_evaluation_recognition",
        "label_evaluation_inProgress",
        "label_evaluation_beingAudited",
      ],
      config: {
        width: 400,
        height: 160,
        marginTop: 0,
        marginBottom: 0,
        axisLabelSpacePercentage: 20,
      },
      organizationByStatus: [],
      totalOrganizations: 0
    };
  },
  computed: mapGetters(["getOrganizationsByStatus"]),
  mounted() {
    this.formatAwardByStatus()
  },
  watch: {
    'getOrganizationsByStatus.data': {
      handler: function () {
        this.formatAwardByStatus();
      },
      deep: true
    }
  },
  methods: {
    formatAwardByStatus: function () {
      this.organizationByStatus = this.getOrganizationsByStatus.data;
      this.totalOrganizations = this.organizationByStatus.reduce((prev, current) => prev + current.value, 0);
    },
  },
};
</script>

<template>

  <div style="
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
">

    <dashboard-spinner :height="220" v-if="this.getOrganizationsByStatus.loading"/>


      <dashboard-no-data v-if="!this.getOrganizationsByStatus.loading && !this.organizationByStatus.length"></dashboard-no-data>

    <div style="width: 100%;" v-if="!this.getOrganizationsByStatus.loading && this.organizationByStatus.length">
      <horizontal-stacked-bar-chart
        :chart-data="organizationByStatus"
        :colors="colors"
        :custom-group-sorting="groups"
        :config="config"
        :parent-height="false"
      >
      </horizontal-stacked-bar-chart>
    </div>
    <dashboard-total v-if="!this.getOrganizationsByStatus.loading && this.organizationByStatus.length" style="  padding-top: 15px;" :total-organizations="totalOrganizations"></dashboard-total>
  </div>

</template>

<style scoped lang="scss">

</style>
